import StatsCard from "./StatsCard";

const getColClass = (count) => {
  if (count >= 5) {
    return "col-xl-2 col-lg-4 col-md-6 col-sm-6";
  }

  if (count === 4) {
    return "col-xl-3 col-lg-6 col-md-6 col-sm-6";
  }

  return "col-xl-4 col-lg-4 col-md-6 col-sm-6";
};

const StatsRow = ({ title, stats = [], isCurrency = false }) => {
  const colClass = getColClass(stats.length);

  return (
    <div className="mb-4">
      <h4 className="card-title mb-3">{title}</h4>

      <div className="row">
        {stats.map((item) => (
          <div className={`${colClass} mb-3`} key={item.key}>
            <StatsCard
              label={item.label}
              value={item.value}
              tone={item.tone}
              icon={item.icon}
              isCurrency={isCurrency}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsRow;
